const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:8000";

const getHeaders = () => {
  const token = localStorage.getItem("token");

  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
};

export const getAllPMs = async () => {
  const response = await fetch(
    `${API_BASE_URL}/api/get_all_pms/`,
    {
      headers: getHeaders(),
    }
  );

  return await response.json();
};

export const getPendingPMs = async () => {
  const response = await fetch(
    `${API_BASE_URL}/api/pending-pms/`,
    {
      headers: getHeaders(),
    }
  );

  return await response.json();
};

export const approvePM = async (id) => {
  const response = await fetch(
    `${API_BASE_URL}/api/approve_pm/${id}/`,
    {
      method: "POST",
      headers: getHeaders(),
    }
  );

  return await response.json();
};

export const updatePM = async (id, data) => {
  const response = await fetch(
    `${API_BASE_URL}/api/update_pm/${id}/`,
    {
      method: "POST",
      headers: getHeaders(),
      body: JSON.stringify(data),
    }
  );

  return await response.json();
};

export const deletePM = async (id, body = {}) => {
  const response = await fetch(
    `${API_BASE_URL}/api/delete_pm/${id}/`,
    {
      method: "POST",
      headers: getHeaders(),
      body: JSON.stringify(body),
    }
  );

  const data = await response.json();

  if (!response.ok) {
    throw data;
  }

  return data;
};


export const createPM = async (data) => {
  const response = await fetch(
    `${API_BASE_URL}/api/create_pm/`,
    {
      method: "POST",
      headers: {
        ...getHeaders(),
        Accept: "application/json",
      },
      body: JSON.stringify(data),
    }
  );

  const result = await response.json();

  if (!response.ok) {
    throw new Error(
      result.error ||
      result.message ||
      "Failed to create PM"
    );
  }

  return result;
};